import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCRhZeO_XqIVQ5562AjJAlThv94XOP3ndI",
  authDomain: "restaurant-karlovo-9dd6e.firebaseapp.com",
  projectId: "restaurant-karlovo-9dd6e",
  storageBucket: "restaurant-karlovo-9dd6e.firebasestorage.app",
  messagingSenderId: "29357705482",
  appId: "1:29357705482:web:6f562b09b5ca3433bad2f3",
  measurementId: "G-ZRKPVW5QJP" 
};

const app = initializeApp(firebaseConfig);

// ТУК ВРЪЩАМЕ ИМЕТО НА ТВОЯТА БАЗА ДАННИ (rtkdb)
export const db = getFirestore(app, "rtkdb");

export const storage = getStorage(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

export const analytics = getAnalytics(app);